import { render } from "./registerLocationAdmin.vue?vue&type=template&id=b1b536e8"
import script from "./registerLocationAdmin.vue?vue&type=script&lang=js"
export * from "./registerLocationAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__